import { updateBulletData, processBullets } from '../utils';
import { Button } from '@chakra-ui/react';
import { switchBullets } from '../handlers';
import { handleEditable } from '../../../handlers';
import { updateSectionData } from '../../../handlers/utils';
import { runAxios } from '../../../handlers/axios';
import { getUsefulVars } from '../../../handlers/helpers';

export const openBulletRow = (stateProps) => {
  if(stateProps.openBulletRow.open) {
    stateProps.setOpenBulletRow({ open: false });
  } else {
    stateProps.setOpenBulletRow({open:true});
  }
}
export const getBulletRow = (bulletRow, stateProps, buttonStyles) => {
  return (
    Object.entries(bulletRow).map((bulletGroup) => {
        let bulletName = bulletGroup[0];
        bulletName = bulletName.charAt(0).toUpperCase() + bulletName.slice(1);
        let buttonVariant = {...buttonStyles.bulletTag};
        if (bulletGroup[0] === stateProps.bulletData.bulletGroup) {
          buttonVariant = {...buttonStyles.bulletTagActive};
        }
        let width= '120px';
        if(bulletGroup[0] === 'recommended') {
          width='180px';
        }
        return (

          <Button
            width={width}
            sx={buttonVariant}
            onClick={e => {
              switchBullets(stateProps, bulletGroup[0]);
            }}
          >
            {bulletName}
          </Button>
        );
      },
    )
  );
};

export const fetchMoreBullets = (jobSeekerData, props ) => {
  const stateProps = props.stateProps;
  const keywordInput = document.querySelector('#bulletSearch');
  const keyword = keywordInput.value;
  stateProps.bullets = [];
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resume = stateProps.dataToSave.saved.resumes[resumeIndex];
  const target_job_title = resume['job_title'];
  const job_title = jobSeekerData[stateProps.sectionData.sectionIndex]['job_title'];

  fetchSearchBulletsFromAI(props, jobSeekerData, target_job_title, job_title, keyword);
};

const getBulletsToMove = (counter, bulletsToMove, bullets, numBulletsToAdd) => {
  for (const bullet of bullets) {
    //get bullets up to numBulletsToAdd or all if numBulletsToAdd = -1
    if (counter >= numBulletsToAdd && numBulletsToAdd !== -1) {
      break;
    }
    //God loves me, so take a hike with your judgemental eyes
    if(!bullet.label.includes('{{')) {
      bulletsToMove.push(bullet);
    }
    counter++;
  }
  return bulletsToMove;
};
const fillInBulletsFromAICallback = (result, args) => {

  const uv = getUsefulVars(args.props);
  const step = args.step
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const sectionIndex = args.sectionIndex;
  const industry = args.industry;

  //get bullets from ai response
  let newBullets = JSON.parse(result.data);

  newBullets.existing = uv.resume['professional-experience'][sectionIndex].existing;
  //keep already saved bullets
  let savedBullets = typeof jobSeekerData[sectionIndex]['bulletsb'] !== 'undefined' ? jobSeekerData[sectionIndex]['bulletsb'] : [];
  let savedBulletsLength = typeof savedBullets === 'undefined' ? 0 : savedBullets.length;

  //calculate number of bullets to add
  let numBulletsToAdd = 6 - savedBulletsLength;

  //get unselected recommended Bullets
  let unselectedRecommendBullets = [];
  for(const bullet of newBullets['recommended']) {
      unselectedRecommendBullets.push(bullet);
  }

  let bulletsToMove = [];
  bulletsToMove = getBulletsToMove(0, bulletsToMove, newBullets['recommended'], numBulletsToAdd);
  //add recommended to saved.
  for (const bullet of bulletsToMove) {
    savedBullets.unshift(bullet);
  }

  //reduce unselected recommended
  unselectedRecommendBullets = unselectedRecommendBullets.filter(item => !bulletsToMove.includes(item));
  //set up initial freeform bullet
  newBullets.freeform = [{
    'label': '{{add text}}',
    'key': 'ff-1',
    'type': 'freeform',
    'questions': [],
  }];
  newBullets['recommended'] = unselectedRecommendBullets;
  newBullets = processBullets(newBullets, jobSeekerData, sectionIndex, newBullets['freeform']);
  newBullets = processBullets(newBullets, jobSeekerData, sectionIndex, newBullets['fillable']);
  newBullets = processBullets(newBullets, jobSeekerData, sectionIndex, newBullets['recommended']);
  //get recommended bullets to add to selected from recommended list based on number of bullets to add



  //get existing bullets to add to selected from generic list based on number of bullets to add
  /*bulletsToMove = getBulletsToMove(0, bulletsToMove, newBullets['existing'], -1);
  savedBullets = savedBullets.concat(bulletsToMove);*/

  //recalculate number of bullets to add
  bulletsToMove = [];
  savedBulletsLength = savedBullets === undefined ? 0 : savedBullets.length;
  numBulletsToAdd = 6 - savedBulletsLength;

  //get generic bullets to add to selected from generic list based on number of bullets to add
  if(numBulletsToAdd > 0) {
    bulletsToMove = getBulletsToMove(0, bulletsToMove, newBullets['generic'], numBulletsToAdd);
    savedBullets = savedBullets.concat(bulletsToMove);
  }
  //reduce unselected generic bullets
  newBullets.generic = newBullets.generic.filter((element) => !bulletsToMove.includes(element));

  //set targetGroup of bullets to appear in the unselected window.
 // const targetGroup = unselectedRecommendBullets.length === 0 ? 'fillable' : 'recommended';
const targetGroup = 'fillable';
  updateBulletData({
    bulletsLoaded: true,
    bullets: newBullets,
    unselectedBullets: newBullets,
    selectedBullets: savedBullets,
    bulletGroup: targetGroup,
    bulletValue: {},
  }, uv.stateProps);


  updateSectionData({
    sectionType: 'industry',
    industryType: industry,
    sectionIndex: uv.stateProps.sectionData.sectionIndex,

  }, uv.stateProps);

  //add saved bullets to selected window
  jobSeekerData[sectionIndex]['bulletsb'] = savedBullets;
  const stepIndex = step==='first' ? 0 : uv.stateProps.dataToSave.industry.other.questions.length-1;
  uv.stateProps.setSpinnerImage('default.gif');
  uv.stateProps.setSpinnerMessage('');
  uv.stateProps.onSpinnerClose();
  handleEditable(uv.stateProps, sectionIndex, stepIndex);


};
export const fillInBulletsFromAI = (props, jobSeekerData, target_job_title, job_title, secondMulti, step='first') => {

  const stateProps = props.stateProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const sectionIndex = stateProps.sectionData.sectionIndex;
  const url = stateProps.domain + '/wp-json/rsworks/v1/enterBulletBank';
  const pe = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'][sectionIndex];
  const jobSeekerIndustry = typeof pe['industry'] !== 'undefined' ? pe['industry'] : '';
  const targetIndustry = stateProps.dataToSave.saved.resumes[resumeIndex].industry[0];
  const industry = stateProps.dataToSave.saved.resumes[resumeIndex]['industry'];
  const recommendedQuestions = [];
  if(typeof stateProps.dataToSave.industry['other'] !== 'undefined') {
    for (const question of stateProps.dataToSave.industry['other'].questions) {
      const id = question.qid;
      if(id !== 'bullets-bacon') {
        if (jobSeekerData[sectionIndex][id] !== undefined) {
          const response = jobSeekerData[sectionIndex][id];
          recommendedQuestions.push({ question: question.question, qid: id, response: response });
        } else {
          const response = '{{}}';
          recommendedQuestions.push({ question: question.question, qid: id, response: response });
        }
      }
    }
  }
  const request = {
    'target_job_title': target_job_title,
    'target_industry': targetIndustry,
    'job_title': job_title,
    'industry': jobSeekerIndustry[0],
    'searched_term': '',
    'recommendedQuestions': recommendedQuestions,
  };
  const args = {
    props: props,
    message: 'Get initial bullets from AI',
    sectionIndex: sectionIndex,
    industry: industry,
    step: step,
      secondMulti:secondMulti,

  };

  stateProps.setSpinnerMessage('Our resume wizards are working hard to showcase your accomplishments.\n'
  + ' (This may take a minute or two) ');
  stateProps.setSpinnerImage('questions.gif');
  stateProps.onSpinnerOpen();
  runAxios(url, request, fillInBulletsFromAICallback, args);

};

/**
 *
 * @param result
 * @param args
 */
const fetchSearchBulletsFromAICallback = (result, args) => {
  const props = args.props;
  const stateProps = props.stateProps;

  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const sectionIndex = args.sectionIndex;
  const industry = args.industry;
  //const bullets = JSON.parse(result.data);
  //const fetchedBullets = JSON.parse(JSON.stringify(bullets));
  const searchedBullets = result.data;
  const newBullets = JSON.parse(JSON.stringify(stateProps.bulletData.unselectedBullets));
  newBullets.searched = searchedBullets;
  let savedBullets = typeof jobSeekerData[sectionIndex]['bulletsb'] !== 'undefined' ? jobSeekerData[sectionIndex]['bulletsb'] : [];

  const targetGroup = 'searched';

  updateBulletData({
    bulletsLoaded: true,
    bullets: newBullets,
    unselectedBullets: newBullets,
    selectedBullets: savedBullets,
    bulletGroup: targetGroup,
  }, stateProps);


  updateSectionData({
    sectionType: 'industry',
    industryType: industry,
    sectionIndex: stateProps.sectionData.sectionIndex,

  }, stateProps);

  jobSeekerData[sectionIndex]['bulletsb'] = savedBullets;
  stateProps.setSpinnerImage('default.gif');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
  const step = stateProps.dataToSave.industry['other']['questions'].length-1;
  handleEditable(stateProps, sectionIndex, step);
};

/**
 *
 * @param props
 * @param jobSeekerData
 * @param target_job_title
 * @param job_title
 * @param searchedTerm
 */
export const fetchSearchBulletsFromAI = (props, jobSeekerData, target_job_title, job_title, searchedTerm) => {

  const stateProps = props.stateProps;
  stateProps.setisai(true);
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const sectionIndex = stateProps.sectionData.sectionIndex;
  const url = stateProps.domain + '/wp-json/rsworks/v1/getSearchBullets';
  const pe = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'][sectionIndex];
  const jobSeekerIndustry = typeof pe['industry'] !== 'undefined' ? pe['industry'][0] : '';
  const target_industry =stateProps.dataToSave.saved.resumes[resumeIndex]['industry'][0];
  const industry = typeof stateProps.dataToSave.industry[jobSeekerIndustry] !== 'undefined' ? jobSeekerIndustry : 'other';

  const request = {
    'target_job_title': target_job_title,
    'target_industry': target_industry,
    'job_title': job_title,
    'searched_term': searchedTerm,
    'industry': industry,
  };
  const args = {
    props: props,
    message: 'Fetch Search Bullets from AI',
    sectionIndex: sectionIndex,
    industry: industry,
  };
  stateProps.setSpinnerMessage('Crafting amazing bullets that will make you shine...');
  stateProps.setSpinnerImage('bulletSearch.gif');
  stateProps.onSpinnerOpen();

  runAxios(url, request, fetchSearchBulletsFromAICallback, args);
};